import { faMapMarkerAlt, faStar } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useEffect, useState } from "react";
import BurgerMenuTitle from "../../Component/BurgerMenuTitle/BurgerMenuTitle";
import Style from "./FavoriteRestaurant.module.css";
import { getFavoritePro, getFavoriteSup } from "../../Api/ClientServices";
import PointSpreadLoading from "react-loadingg/lib/PointSpreadLoading";
import { Link, useHistory } from "react-router-dom";
import { separate } from "../../Seprate/Seprate";
import { errorToast } from "../../Toast/Toast";

const FavoriteRestaurant = () => {
  const [suplier, setSuplier] = useState([]);
  const [product, setProduct] = useState([]);
  const history=useHistory()
  useEffect(() => {
    getFavoriteList();
  }, []);

  const getFavoriteList = async () => {
    getFavoriteSup((succ, res) => {
      if (succ) {
        if (res.status === 1) {
          setSuplier([]);
        } else {
          setSuplier(res.favorites);
        }
      } else {
        console.error(res);
      }
    });
    getFavoritePro((succ, res) => {
      if (succ) {
        if (res.status === 0) {
          setProduct([]);
        } else {
          setProduct(res.favorites);
        }
      } else {
        console.error(res);
      }
    });
  };

  let loading = null;
  let loading2 = null;
  if (suplier === undefined && product === undefined) {
    loading = <PointSpreadLoading color={"#ab0c59"} size={"small"} />;

    loading2 = <PointSpreadLoading color={"#ab0c59"} size={"small"} />;
  } else if (suplier.length === 0 && product.length === 0) {
    loading = <h2 className={Style.text}>!علاقمندی یافت نشد</h2>;
  } else {
    loading = suplier.map((item) => {
      return (
        <section key={item.id} className={Style.RestaurantInfoHolder}>
          <div className={Style.RestaurantInfoHolder__TopPart}>
            <div className={Style.ImageHolder}>
              <img
                src={`//cdn.barest.ir/supplier/logo/${item.logo}.jpg`}
                alt="رستوران"
              />
            </div>
            <div className={Style.TextHolder}>
              <h3 className={Style.supplierName}>{item.name}</h3>
              <div className={Style.StoreRate}>
                <div className={Style.FixRate}>
                  <div className={Style.RateHolder}>
                    <div className={Style.grayStar}>
                      <FontAwesomeIcon icon={faStar} />
                      <FontAwesomeIcon icon={faStar} />
                      <FontAwesomeIcon icon={faStar} />
                      <FontAwesomeIcon icon={faStar} />
                      <FontAwesomeIcon icon={faStar} />
                    </div>
                    <div
                      className={Style.GoldStar}
                      style={{ width: `${item.supplier_rate * 20}%` }}
                    >
                      <div className={Style.GoldStarHolder}>
                        <FontAwesomeIcon icon={faStar} />
                        <FontAwesomeIcon icon={faStar} />
                        <FontAwesomeIcon icon={faStar} />
                        <FontAwesomeIcon icon={faStar} />
                        <FontAwesomeIcon icon={faStar} />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className={Style.AddressHolder}>
                <FontAwesomeIcon
                  style={{
                    color: "#c20c64",
                    marginLeft: ".5rem",
                    fontSize: ".9rem",
                  }}
                  icon={faMapMarkerAlt}
                />
                {item.address}
              </div>
            </div>
          </div>
          <div className={Style.buttonHolder}>
            <Link to={`supplier/${item.id}/`} className={Style.buyBtn}>
              خرید در این فروشگاه
            </Link>
          </div>
        </section>
      );
    });
    loading2 = product.map((item) => {
      return (
        <section key={item.id} className={Style.RestaurantInfoHolder}>
          <div className={Style.RestaurantInfoHolder__TopPart}>
            <div className={Style.ImageHolder}>
              <img
                src={`//cdn.barest.ir/product/m/${item.id}.jpg`}
                alt="رستوران"
              />
            </div>
            <div className={Style.TextHolder}>
              <h3 className={Style.supplierName} onClick={()=>history.push(`/product/${item.id}/${item.supplier_id}`)}>{item.supplier}</h3>
              <h3 className={Style.productName}>{item.name}</h3>
              {item.other_detail === "" ? null : (
                <div className={Style.AddressHolder}>{item.other_detail}</div>
              )}
              <div className={Style.priceHolder}>
                {parseInt(item.off_price) === 0 ? null : (
                  <h3 className={Style.withoutOff}>
                    {" "}
                    {separate(item.off_price)} تومان{" "}
                  </h3>
                )}

                {parseInt(item.off_price) === 0 ? (
                  <h3 className={Style.withoutOff}>
                    {" "}
                    {separate(item.price)} تومان{" "}
                  </h3>
                ) : (
                  <h3 className={Style.withOff}>
                    {" "}
                    {separate(item.price)} تومان{" "}
                  </h3>
                )}
              </div>
            </div>
          </div>
          <div className={Style.buttonHolder}>
            <Link to={`supplier/${item.supplier_id}/`} className={Style.buyBtn}>
              خرید در این فروشگاه
            </Link>
          </div>
        </section>
      );
    });
  }
  return (
    <div className={Style.PageHolder}>
      <BurgerMenuTitle title={" موردعلاقه های من"} />
      {loading}

      {loading2}
    </div>
  );
};
export default FavoriteRestaurant;
